import { AnalyticsEvent, captureAnalyticsEvent } from '../../../constant/Events';

export enum DataTablePage {
  OVERVIEW = 'Overview',
  CHARGERS = 'Chargers',
  CHARGER_DETAILS = 'Charger Details',
  LICENSES = 'Licenses',
  PROMOTIONS = 'Promotions',
}

export enum DataTableName {
  CHARGERS = 'Chargers',
  LICENSES = 'Licenses',
  SESSIONS = 'Sessions',
  PROMOTIONS = 'Promotions',
}

export const exportDataTableToCSV = (
  rows: string[][],
  headerMap: Record<string, string>,
  visibleColumnIds: string[],
  fileNamePrefix: string,
  page: DataTablePage,
  table: DataTableName,
) => {
  captureExportAsCSVEvent(page, table, visibleColumnIds);
  const headers = visibleColumnIds.map((colId) => headerMap[colId] || colId);

  const csvContent = [
    headers.join(','),
    ...rows.map((row) =>
      row.map((cell: string) => `"${String(cell).replace(/"/g, '""')}"`).join(','),
    ),
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${fileNamePrefix}_${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
};

export const captureSortColumnEvent = (
  page: DataTablePage,
  table: DataTableName,
  columnId: string,
) => {
  captureAnalyticsEvent(AnalyticsEvent.DATA_TABLE_SORT_COLUMN_EVENT, {
    page,
    table,
    column: columnId,
  });
};

export const captureExportAsCSVEvent = (
  page: DataTablePage,
  table: DataTableName,
  columnsExported: string[],
) => {
  captureAnalyticsEvent(AnalyticsEvent.DATA_TABLE_EXPORT_AS_CSV_EVENT, {
    page,
    table,
    columns: columnsExported.join(','),
  });
};
